const scrollDownAnimation = {

        v: "5.5.8",
        fr: 30,
        ip: 0,
        op: 60,
        w: 512,
        h: 512,
        nm: "arrow_scroll",
        ddd: 0,
        assets: [],
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Shape Layer 2",
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.52
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0.167
                      ]
                    },
                    t: 20,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.985
                      ],
                      y: [
                        0.3
                      ]
                    },
                    o: {
                      x: [
                        0.48
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 40,
                    s: [
                      100
                    ]
                  },
                  {
                    t: 60,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              r: {
                a: 0,
                k: 0,
                ix: 10
              },
              p: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.18,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.167
                    },
                    t: 20,
                    s: [
                      256,
                      278.61504,
                      0
                    ],
                    to: [
                      0,
                      0.556,
                      0
                    ],
                    ti: [
                      0,
                      -0.556,
                      0
                    ]
                  },
                  {
                    t: 40,
                    s: [
                      256,
                      295.68,
                      0
                    ]
                  }
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  -164.856,
                  371.65,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  498.55488,
                  512,
                  100
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            -185.644,
                            367.9
                          ],
                          [
                            -174.691,
                            375.4
                          ],
                          [
                            -163.856,
                            367.9
                          ]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Path 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ],
                      ix: 3
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 4
                    },
                    w: {
                      a: 0,
                      k: 4,
                      ix: 5
                    },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Stroke 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        94.338,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Shape 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 61,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 1",
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.52
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0.167
                      ]
                    },
                    t: 0,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.985
                      ],
                      y: [
                        0.16
                      ]
                    },
                    o: {
                      x: [
                        0.48
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 20,
                    s: [
                      100
                    ]
                  },
                  {
                    t: 44,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              r: {
                a: 0,
                k: 0,
                ix: 10
              },
              p: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.17,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.167
                    },
                    t: 0,
                    s: [
                      256,
                      182.18496,
                      0
                    ],
                    to: [
                      0,
                      1.111,
                      0
                    ],
                    ti: [
                      0,
                      -1.111,
                      0
                    ]
                  },
                  {
                    t: 20,
                    s: [
                      256,
                      216.32,
                      0
                    ]
                  }
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  -164.856,
                  371.65,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  498.55488,
                  512,
                  100
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            -185.644,
                            367.9
                          ],
                          [
                            -174.691,
                            375.4
                          ],
                          [
                            -163.856,
                            367.9
                          ]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Path 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [
                        0.2901960784313726,
                        0.2901960784313726,
                        0.2901960784313726,
                        1
                      ],
                      ix: 3
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 4
                    },
                    w: {
                      a: 0,
                      k: 4,
                      ix: 5
                    },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Stroke 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        94.338,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Shape 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 61,
            st: 0,
            bm: 0
          }
        ],
        markers: []
      
}
export default scrollDownAnimation;